import markers from '/styles/markers.json'

export const addMarkers = (defs) => {
  defs.selectAll('marker')
    .data(markers)
    .enter()
    .append('svg:marker')
      .attr('id', d => d.name)
      .attr('markerHeight', d => d.markerHeight)
      .attr('markerWidth', d => d.markerWidth)
      .attr('orient', 'auto')
      .attr("class", d => d.class)
      .attr('refX', d => d.refX)
      .attr('refY', d => d.refY)
      .attr('viewBox', d => d.viewBox)
      .append('svg:path')
        .attr('d', d => d.path);
};
